import React from 'react';
import { FloatingButton, FloatingButtonsContainer } from 'styles/common/QuickActionStyle';
import { CONTACTS } from 'utils/constants';
import KakaoIcon from 'assets/icons/kakao.png';
import TelIcon from 'assets/icons/tel.png';

const QuickAction = () => {
  return (
    <FloatingButtonsContainer>
      {/* 카카오톡 채널 버튼 */}
      <FloatingButton 
        href={CONTACTS.KAKAO}
        target="_blank" 
        rel="noopener noreferrer"
        className="kakao"
      >
        <img src={KakaoIcon} alt="kakao" />
      </FloatingButton>
      {/* 전화 버튼 */}
      <FloatingButton href={`tel:${CONTACTS.TEL}`} className="tel">
        <img src={TelIcon} alt="tel" />
      </FloatingButton>
    </FloatingButtonsContainer>
  );
};

export default QuickAction;
